import { Icon24VideosLarge } from '@figma/fpl-icons';
import { CompositorIconLocal } from './CompositorIcon';
import { fplIcon } from './fplIcon';

export const VideoConcatenatorIcon = fplIcon(CompositorIconLocal, Icon24VideosLarge);
